






























































import ProfileDebug from './ProfileDebug.vue'
import { Component, Vue } from 'vue-property-decorator'
import '@/icons/delete'
import '@/icons/search'
import '@/icons/user'
import { IClientProfile } from '@/store/models/ClientProfile'

@Component({
  components: {
    ProfileDebug
  }
})
export default class SideBar extends Vue {
  private searchQuery: string = ''

  private get clientProfiles () {
    return this.$store.state.matrix.clientProfiles
  }

  private get searchResults () {
    const searchFilter = this.searchQuery && this.searchQuery.toLowerCase()
    let filtered = this.clientProfiles
    if (searchFilter) {
      filtered = this.clientProfiles.filter((profile: IClientProfile) => {
        return profile.name.toLowerCase().indexOf(searchFilter) > -1
      })
    }
    return filtered
  }

  private deleteProfile (profile: IClientProfile) {
    this.$store.dispatch('matrix/deleteProfile', profile)
      .catch((err) => console.error(err))
  }

  private loadProfile (profile: IClientProfile) {
    this.$emit('close')
    this.$store.dispatch('matrix/loadProfile', profile)
      .then(() => {
        if (this.$route.fullPath !== '/glasses') {
          this.$router.push('/glasses')
            .catch((err) => console.error(err))
        }
      })
      .catch((err) => console.error(err))
  }
}
